export class JSUtils {
    static runMicroTask(fn: () => any) {
        try {
            (async () => fn())();
        } catch (e) {
            console.error(e)
        }
    }

    static runMacroTask(fn: () => any) {
        setTimeout(() => {
            try {
                fn();
            } catch (e) {
                console.error(e)
            }
        });
    }
}